export class GroupedMarkers {
  private grouped: { [key: string]: google.maps.marker.AdvancedMarkerElement[] } = {};

  constructor(markers: google.maps.marker.AdvancedMarkerElement[]) {
    this.groupMarkersByPosition(markers);
  }

  private groupMarkersByPosition(markers: google.maps.marker.AdvancedMarkerElement[]): void {
    markers.forEach(marker => {
      const key = `${marker.position!.lat},${marker.position!.lng}`;
      if (!this.grouped[key]) {
        this.grouped[key] = [];
      }
      this.grouped[key].push(marker);
    });
  }

  getGroups(): { [key: string]: google.maps.marker.AdvancedMarkerElement[] } {
    return this.grouped;
  }

  getMarkersInGroup(key: string): google.maps.marker.AdvancedMarkerElement[] | undefined {
    return this.grouped[key];
  }
}
